import { LanguageService, SiteContext } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

export function languageToCustom(lang: string): string {
  return lang && lang.split('_')[0];
}

@Injectable({
  providedIn: 'root'
})
export class CustomLanguageService implements SiteContext<string> {
  constructor(protected langService: LanguageService) {}

  getActive(): Observable<string> {
    return this.langService.getActive().pipe(
      map(languageToCustom)
    );
  }

  setActive(country: string): Observable<boolean> {
    return this.langService.getAll().pipe(
      map((languages) => {
        const found = languages.find((lang) => country === languageToCustom(lang.isocode));
        if (found) {
          this.langService.setActive(found.isocode);
          return true;
        }
        return false;
      })
    );
  }

  getAll(): Observable<string[]> {
    return this.langService.getAll().pipe(
      map((languages) => languages.map((lang) => languageToCustom(lang.isocode)))
    );
  }
}
